import { render, staticRenderFns } from "./SendCouponAddShops.vue?vue&type=template&id=061c8ec3&scoped=true&"
import script from "./SendCouponAddShops.vue?vue&type=script&lang=js&"
export * from "./SendCouponAddShops.vue?vue&type=script&lang=js&"
import style0 from "./SendCouponAddShops.vue?vue&type=style&index=0&id=061c8ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c8ec3",
  null
  
)

export default component.exports